// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../work/nmcp-client/nmcp-client/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../work/nmcp-client/nmcp-client/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * @license
 * Copyright 2018 Google Inc.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

.neuroglancer-annotations-tab {
  display: flex;
  align-items: stretch;
  flex: 1;
  flex-direction: column;
}

.neuroglancer-annotation-list {
  position: relative;
  margin: 0px;
  padding: 0px;
  margin-top: 2px;
  overflow-y: auto;
  height: 0px;
  flex: 1;
  flex-basis: 0px;
  min-height: 0px;
}

.neuroglancer-annotation-list-entry {
  display: grid;
  grid-auto-rows: min-content;
  cursor: pointer;
  justify-content: start;
}

.neuroglancer-annotation-position {
  display: contents;
}

.neuroglancer-annotation-layer-view {
  display: flex;
  flex-direction: column;
  flex: 1;
  align-items: stretch;
}

.neuroglancer-annotation-list-header {
  grid-auto-rows: min-content;
  display: grid;
  padding-bottom: 2px;
  justify-content: start;
}

.neuroglancer-annotation-coordinate {
  font-family: monospace;
  text-align: right;
}

.neuroglancer-annotation-icon {
  grid-column: symbol;
  padding-right: 5px;
}

.neuroglancer-annotation-description {
  grid-column: dim / -1;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}

.neuroglancer-annotation-list-entry-delete {
  grid-column: delete;
  margin-left: 1ch;
  align-self: start;
  visibility: hidden;
}

.neuroglancer-annotation-list-entry:hover
  > .neuroglancer-annotation-list-entry-delete {
  visibility: visible;
}

.neuroglancer-annotation-hover {
  background-color: #333;
}

.neuroglancer-annotation-selected {
  background-color: #939;
}

.neuroglancer-annotation-hover.neuroglancer-annotation-selected {
  background-color: #969;
}

.neuroglancer-tab-content.neuroglancer-annotation-details {
  flex: 0 0 auto;
  align-self: stretch;
  display: flex;
  flex-direction: column;

  -webkit-touch-callout: default;
  -webkit-user-select: text;
  -khtml-user-select: text;
  -moz-user-select: text;
  -ms-user-select: text;
  user-select: text;
}

.neuroglancer-annotation-details-title {
  display: flex;
  flex-direction: row;
  background-color: #03c;
  align-self: stretch;
  padding: 2px;
}

.neuroglancer-voxel-coordinates-link {
  cursor: pointer;
}

.neuroglancer-voxel-coordinates-link:hover {
  background-color: #db4437;
}

.neuroglancer-annotation-details-icon {
  display: inline-block;
  margin-right: 5px;
}

.neuroglancer-annotation-details-title-text {
  display: inline-block;
  flex: 1;
}

textarea.neuroglancer-annotation-details-description {
  align-self: stretch;
  background-color: #222;
  color: white;
  font: 10pt sans-serif;
  border: 0px;
  outline: 0px;
  resize: none;
  overflow-y: scroll;
}

div.neuroglancer-annotation-details-description {
  align-self: stretch;
  color: white;
  font: 10pt sans-serif;
}

.neuroglancer-annotation-details-position {
}

.neuroglancer-annotation-toolbox {
  display: flex;
  align-items: stretch;
}

.neuroglancer-annotation-segment-list {
}

.neuroglancer-annotation-segment-item {
  color: black;
  background-color: white;
}

.neuroglancer-annotations-view-dimension {
  font-family: monospace;
  text-align: right;
}

.neuroglancer-annotations-view-dimension-name {
  color: #ff6;
}

.neuroglancer-annotations-view-dimension-scale {
  color: #bbb;
}

.neuroglancer-annotations-view-dimension-scale:not(:empty)::before {
  content: "(";
  margin-left: 1ch;
}

.neuroglancer-annotations-view-dimension-scale:not(:empty)::after {
  content: ")";
}

.neuroglancer-annotation-relationship-label,
.neuroglancer-annotation-property-label {
  margin-right: 5px;
}

.neuroglancer-selected-annotation-details-position-grid {
  display: grid;
  grid-auto-rows: auto;
  font-family: monospace;
  font-size: medium;
  grid-auto-flow: dense;
}

.neuroglancer-selected-annotation-details-icon {
  grid-rows: 1 / -1;
  grid-column: icon;
  align-self: start;
}

.neuroglancer-selected-annotation-details-delete {
  grid-rows: 1 / -1;
  grid-column: delete;
  align-self: start;
}

.neuroglancer-selected-annotation-details-position-dim {
  color: #ff6;
  margin-left: 1ch;
}

.neuroglancer-selected-annotation-details-position-coord {
  text-align: right;
  margin-left: 0.5ch;
}

.neuroglancer-related-segment-list-title {
  font-family: sans-serif;
  font-size: small;
  background-color: #333;
}

.neuroglancer-related-segment-list-header {
  display: flex;
  flex-direction: row;
}

.neuroglancer-related-segment-list {
  /*  border: 1px solid #333;
  margin: 3px;*/
}

.neuroglancer-annotation-property {
  display: flex;
  flex-direction: row;
  font-family: sans-serif;
  font-size: small;
  user-select: text;
}

.neuroglancer-annotation-property-label {
  color: #999;
}

.neuroglancer-annotation-property-value {
  text-align: right;
  font-family: monospace;
  font-size: medium;
  flex: 1;
}

input.neuroglancer-segment-list-entry-id {
  outline: 0px;
  border: 0px;
  text-align: left;
}

.neuroglancer-segment-list-entry-new > .neuroglancer-segment-list-entry-copy {
  visibility: hidden;
}

.neuroglancer-segment-list-entry-new > input[type="checkbox"] {
  visibility: hidden;
}

.neuroglancer-selection-annotation-status {
  font-family: sans-serif;
  font-size: small;
}
`, "",{"version":3,"sources":["webpack://./../../../../nmcp-neuroglancer/dist/package/lib/ui/annotations.css"],"names":[],"mappings":"AAAA;;;;;;;;;;;;;;EAcE;;AAEF;EACE,aAAa;EACb,oBAAoB;EACpB,OAAO;EACP,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,OAAO;EACP,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,2BAA2B;EAC3B,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,OAAO;EACP,oBAAoB;AACtB;;AAEA;EACE,2BAA2B;EAC3B,aAAa;EACb,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,uBAAuB;EACvB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,aAAa;EACb,sBAAsB;;EAEtB,8BAA8B;EAC9B,yBAAyB;EACzB,wBAAwB;EACxB,sBAAsB;EACtB,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;EACrB,OAAO;AACT;;AAEA;EACE,mBAAmB;EACnB,sBAAsB;EACtB,YAAY;EACZ,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,qBAAqB;AACvB;;AAEA;AACA;;AAEA;EACE,aAAa;EACb,oBAAoB;AACtB;;AAEA;AACA;;AAEA;EACE,YAAY;EACZ,uBAAuB;AACzB;;AAEA;EACE,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,YAAY;AACd;;AAEA;;EAEE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,oBAAoB;EACpB,sBAAsB;EACtB,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;EACvB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE;eACa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,sBAAsB;EACtB,iBAAiB;EACjB,OAAO;AACT;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;EACvB,gBAAgB;AAClB","sourcesContent":["/**\n * @license\n * Copyright 2018 Google Inc.\n * Licensed under the Apache License, Version 2.0 (the \"License\");\n * you may not use this file except in compliance with the License.\n * You may obtain a copy of the License at\n *\n *      http://www.apache.org/licenses/LICENSE-2.0\n *\n * Unless required by applicable law or agreed to in writing, software\n * distributed under the License is distributed on an \"AS IS\" BASIS,\n * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.\n * See the License for the specific language governing permissions and\n * limitations under the License.\n */\n\n.neuroglancer-annotations-tab {\n  display: flex;\n  align-items: stretch;\n  flex: 1;\n  flex-direction: column;\n}\n\n.neuroglancer-annotation-list {\n  position: relative;\n  margin: 0px;\n  padding: 0px;\n  margin-top: 2px;\n  overflow-y: auto;\n  height: 0px;\n  flex: 1;\n  flex-basis: 0px;\n  min-height: 0px;\n}\n\n.neuroglancer-annotation-list-entry {\n  display: grid;\n  grid-auto-rows: min-content;\n  cursor: pointer;\n  justify-content: start;\n}\n\n.neuroglancer-annotation-position {\n  display: contents;\n}\n\n.neuroglancer-annotation-layer-view {\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n  align-items: stretch;\n}\n\n.neuroglancer-annotation-list-header {\n  grid-auto-rows: min-content;\n  display: grid;\n  padding-bottom: 2px;\n  justify-content: start;\n}\n\n.neuroglancer-annotation-coordinate {\n  font-family: monospace;\n  text-align: right;\n}\n\n.neuroglancer-annotation-icon {\n  grid-column: symbol;\n  padding-right: 5px;\n}\n\n.neuroglancer-annotation-description {\n  grid-column: dim / -1;\n  text-overflow: ellipsis;\n  overflow: hidden;\n  white-space: nowrap;\n}\n\n.neuroglancer-annotation-list-entry-delete {\n  grid-column: delete;\n  margin-left: 1ch;\n  align-self: start;\n  visibility: hidden;\n}\n\n.neuroglancer-annotation-list-entry:hover\n  > .neuroglancer-annotation-list-entry-delete {\n  visibility: visible;\n}\n\n.neuroglancer-annotation-hover {\n  background-color: #333;\n}\n\n.neuroglancer-annotation-selected {\n  background-color: #939;\n}\n\n.neuroglancer-annotation-hover.neuroglancer-annotation-selected {\n  background-color: #969;\n}\n\n.neuroglancer-tab-content.neuroglancer-annotation-details {\n  flex: 0 0 auto;\n  align-self: stretch;\n  display: flex;\n  flex-direction: column;\n\n  -webkit-touch-callout: default;\n  -webkit-user-select: text;\n  -khtml-user-select: text;\n  -moz-user-select: text;\n  -ms-user-select: text;\n  user-select: text;\n}\n\n.neuroglancer-annotation-details-title {\n  display: flex;\n  flex-direction: row;\n  background-color: #03c;\n  align-self: stretch;\n  padding: 2px;\n}\n\n.neuroglancer-voxel-coordinates-link {\n  cursor: pointer;\n}\n\n.neuroglancer-voxel-coordinates-link:hover {\n  background-color: #db4437;\n}\n\n.neuroglancer-annotation-details-icon {\n  display: inline-block;\n  margin-right: 5px;\n}\n\n.neuroglancer-annotation-details-title-text {\n  display: inline-block;\n  flex: 1;\n}\n\ntextarea.neuroglancer-annotation-details-description {\n  align-self: stretch;\n  background-color: #222;\n  color: white;\n  font: 10pt sans-serif;\n  border: 0px;\n  outline: 0px;\n  resize: none;\n  overflow-y: scroll;\n}\n\ndiv.neuroglancer-annotation-details-description {\n  align-self: stretch;\n  color: white;\n  font: 10pt sans-serif;\n}\n\n.neuroglancer-annotation-details-position {\n}\n\n.neuroglancer-annotation-toolbox {\n  display: flex;\n  align-items: stretch;\n}\n\n.neuroglancer-annotation-segment-list {\n}\n\n.neuroglancer-annotation-segment-item {\n  color: black;\n  background-color: white;\n}\n\n.neuroglancer-annotations-view-dimension {\n  font-family: monospace;\n  text-align: right;\n}\n\n.neuroglancer-annotations-view-dimension-name {\n  color: #ff6;\n}\n\n.neuroglancer-annotations-view-dimension-scale {\n  color: #bbb;\n}\n\n.neuroglancer-annotations-view-dimension-scale:not(:empty)::before {\n  content: \"(\";\n  margin-left: 1ch;\n}\n\n.neuroglancer-annotations-view-dimension-scale:not(:empty)::after {\n  content: \")\";\n}\n\n.neuroglancer-annotation-relationship-label,\n.neuroglancer-annotation-property-label {\n  margin-right: 5px;\n}\n\n.neuroglancer-selected-annotation-details-position-grid {\n  display: grid;\n  grid-auto-rows: auto;\n  font-family: monospace;\n  font-size: medium;\n  grid-auto-flow: dense;\n}\n\n.neuroglancer-selected-annotation-details-icon {\n  grid-rows: 1 / -1;\n  grid-column: icon;\n  align-self: start;\n}\n\n.neuroglancer-selected-annotation-details-delete {\n  grid-rows: 1 / -1;\n  grid-column: delete;\n  align-self: start;\n}\n\n.neuroglancer-selected-annotation-details-position-dim {\n  color: #ff6;\n  margin-left: 1ch;\n}\n\n.neuroglancer-selected-annotation-details-position-coord {\n  text-align: right;\n  margin-left: 0.5ch;\n}\n\n.neuroglancer-related-segment-list-title {\n  font-family: sans-serif;\n  font-size: small;\n  background-color: #333;\n}\n\n.neuroglancer-related-segment-list-header {\n  display: flex;\n  flex-direction: row;\n}\n\n.neuroglancer-related-segment-list {\n  /*  border: 1px solid #333;\n  margin: 3px;*/\n}\n\n.neuroglancer-annotation-property {\n  display: flex;\n  flex-direction: row;\n  font-family: sans-serif;\n  font-size: small;\n  user-select: text;\n}\n\n.neuroglancer-annotation-property-label {\n  color: #999;\n}\n\n.neuroglancer-annotation-property-value {\n  text-align: right;\n  font-family: monospace;\n  font-size: medium;\n  flex: 1;\n}\n\ninput.neuroglancer-segment-list-entry-id {\n  outline: 0px;\n  border: 0px;\n  text-align: left;\n}\n\n.neuroglancer-segment-list-entry-new > .neuroglancer-segment-list-entry-copy {\n  visibility: hidden;\n}\n\n.neuroglancer-segment-list-entry-new > input[type=\"checkbox\"] {\n  visibility: hidden;\n}\n\n.neuroglancer-selection-annotation-status {\n  font-family: sans-serif;\n  font-size: small;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
